export interface Photo {
  src: string
  thumbnail: string
  tags: any[]
  caption: string
  des: string
  customOverlay?: any
  thumbnailWidth: number
  thumbnailHeight: number
}

export const photos: Photo[] = [
    {
      src: "https://static.wixstatic.com/media/e49d9d_9238300a75c14650b5e1ce5f0dc8a0fa~mv2_d_6000_3914_s_4_2.jpg",
      thumbnail :"https://static.wixstatic.com/media/e49d9d_9238300a75c14650b5e1ce5f0dc8a0fa~mv2_d_6000_3914_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_9238300a75c14650b5e1ce5f0dc8a0fa~mv2_d_6000_3914_s_4_2.webp",
      tags: [],
      caption: "Hermes",
      des: "Paris",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_a53c503d8d9f41e1ac721bd434751735~mv2_d_6000_4000_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_a53c503d8d9f41e1ac721bd434751735~mv2_d_6000_4000_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_a53c503d8d9f41e1ac721bd434751735~mv2_d_6000_4000_s_4_2.webp",
      tags: [],
      caption: "Maison dela Literie",
      des: "Paris",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_7ed1b268caad4c56a9e15ef7c22e630c~mv2_d_3000_2250_s_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_7ed1b268caad4c56a9e15ef7c22e630c~mv2_d_3000_2250_s_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_7ed1b268caad4c56a9e15ef7c22e630c~mv2_d_3000_2250_s_2.webp",
      tags: [],
      caption: "Coyote",
      des: "Bordeaux",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_38b40b3f3b29474faccc83d916b788d2~mv2_d_2448_3264_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_1eca5f17d62e4dd9b7603c12fd0da32e~mv2_d_4843_3346_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_1eca5f17d62e4dd9b7603c12fd0da32e~mv2_d_4843_3346_s_4_2.webp",
      tags: [],
      caption: "Grubers",
      des: "Monaco",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_38b40b3f3b29474faccc83d916b788d2~mv2_d_2448_3264_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_38b40b3f3b29474faccc83d916b788d2~mv2_d_2448_3264_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_38b40b3f3b29474faccc83d916b788d2~mv2_d_2448_3264_s_4_2.webp",
      tags: [],
      caption: "Shirvan Café Métisse",
      des: "Paris",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_f5f57324939a4fcd8fdbfab7a61a9e63~mv2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_f5f57324939a4fcd8fdbfab7a61a9e63~mv2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_f5f57324939a4fcd8fdbfab7a61a9e63~mv2.webp",
      tags: [],
      caption: "Intermarché",
      des: "Lyon",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_a12acd6eb5dd4bc5b61f46aecbad4081~mv2_d_4287_2802_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_a12acd6eb5dd4bc5b61f46aecbad4081~mv2_d_4287_2802_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_a12acd6eb5dd4bc5b61f46aecbad4081~mv2_d_4287_2802_s_4_2.webp",
      tags: [],
      caption: "Le Balthazar",
      des: "Cannes",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_927e0c2d15d9496aa057f0752a523e1e~mv2_d_3264_2079_s_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_927e0c2d15d9496aa057f0752a523e1e~mv2_d_3264_2079_s_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_927e0c2d15d9496aa057f0752a523e1e~mv2_d_3264_2079_s_2.webp",
      tags: [],
      caption: "Moshi Moshi",
      des:"Monaco",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_740f21b06bf64090b86c50e4261162ca~mv2_d_4924_2443_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_740f21b06bf64090b86c50e4261162ca~mv2_d_4924_2443_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_740f21b06bf64090b86c50e4261162ca~mv2_d_4924_2443_s_4_2.webp",
      tags: [],
      caption: "Co.Espace Bien Être",
      des: "Mandelieu La Napoule",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_2281ec37e2cf45ea82c79e9c1834b17f~mv2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_2281ec37e2cf45ea82c79e9c1834b17f~mv2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_2281ec37e2cf45ea82c79e9c1834b17f~mv2.webp",
      tags: [],
      caption: "Le Comptoir Italien",
      des: "La Rochelle",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_2e16e0be0f6b42748cb0e5d72c41bfda~mv2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_2e16e0be0f6b42748cb0e5d72c41bfda~mv2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_2e16e0be0f6b42748cb0e5d72c41bfda~mv2.webp",
      tags: [],
      caption: "Crazy Cow",
      des: "La Grande Motte",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_164e070d5e5e4cd9abebcc9141de6f66~mv2_d_3264_2448_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_164e070d5e5e4cd9abebcc9141de6f66~mv2_d_3264_2448_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_164e070d5e5e4cd9abebcc9141de6f66~mv2_d_3264_2448_s_4_2.webp",
      tags: [],
      caption: "La Table de Moigné",
      des: "Moigné",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_bd6cf9eebf124745a3b9dcb188bd648c~mv2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_bd6cf9eebf124745a3b9dcb188bd648c~mv2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_bd6cf9eebf124745a3b9dcb188bd648c~mv2.webp",
      tags: [],
      caption: "Baghdad Café",
      des: "Cannes",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_2fc586261e764642a9f5289f3f316009~mv2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_2fc586261e764642a9f5289f3f316009~mv2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_2fc586261e764642a9f5289f3f316009~mv2.webp",
      tags: [],
      caption: "Mozza",
      des: "Monaco",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_f68f9472cb374a8c8a3f089c27bc7042~mv2_d_2447_2447_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_f68f9472cb374a8c8a3f089c27bc7042~mv2_d_2447_2447_s_4_2.jpg/v1/fill/w_380,h_215,al_c,q_80,usm_0.66_1.00_0.01/e49d9d_f68f9472cb374a8c8a3f089c27bc7042~mv2_d_2447_2447_s_4_2.webp",
      tags: [],
      caption: "Sardine",
      des: "Cannes",
      thumbnailWidth: 400,
      thumbnailHeight: 240
    },
  ];
